import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import BlogNewsfeedItemBody from "./blog_newsfeed_item_body";

export default GrComponentFactory.createClass({
  displayName: "BlogNewsfeedItem",

  propTypes: {
    resource: GrPropTypes.blogNewsfeedResource(),
  },

  renderCard() {
    return (
      <div>
        <BlogNewsfeedItemBody resource={this.props.resource} />
      </div>
    );
  },

  render() {
    return <SocialUpdate
      body={this.renderCard()}
      {...this.props}
    />;
  },
});
